module KendoWidgets
{
	export class SliderOptions implements kendo.ui.SliderOptions
	{
		name?: string;
		decreaseButtonTitle?: string;
		dragHandleTitle?: string;
		increaseButtonTitle?: string;
		largeStep?: number;
		max?: number;
		min?: number;
		orientation?: string;
		showButtons?: boolean;
		smallStep?: number;
		tickPlacement?: string;
		tooltip?: kendo.ui.SliderTooltip;
		enabled?: boolean;

		value?: number;
		width?: string | number;
		css?: string;
		color?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		change?(e: kendo.ui.SliderChangeEvent): void;
		slide?(e: kendo.ui.SliderSlideEvent): void;
	}

	export class Slider extends kendo.ui.Slider implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Slider; }
		private _firstLoad: boolean;

		constructor(element: Element, options?: KendoWidgets.SliderOptions)
		{
			if (options == null)
				options = new KendoWidgets.SliderOptions();

			if (options.width == null) options.width = 200;
			if (options.color == null) options.color = KendoWidgets.ColorEnum.BlueVettore;
			if (options.min == null) options.min = 0;
			if (options.max == null) options.max = 100;

			let realMaxValue = Math.abs((options.max - options.min) / 6);
			realMaxValue = (realMaxValue % 5 == 0) ? realMaxValue : realMaxValue + (5 - realMaxValue % 5);
			let realMinValue = realMaxValue / 10;

			options.smallStep = (options.smallStep != null) ? options.smallStep : realMinValue;
			if (options.smallStep <= 0)
				options.smallStep = 1;
			options.largeStep = (options.largeStep != null) ? options.largeStep : realMaxValue;
			if (options.largeStep <= 0)
				options.largeStep = 10;

			super(element, options);

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			this.element.parent().parent().width(options.width);
			//#endregion

			//#region Label
			let label = document.createElement("label");
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				let divContainer = document.createElement("div");
				$(element).closest(".k-slider").wrap(divContainer);

				$("#" + element.id + "Label").remove();
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(element).closest(".k-slider").parent().prepend(label, divContainer.firstChild);
							$(element).closest(".k-slider").parent()[0].style.cssText += "display: inline-flex; flex-direction: column;";
							label.style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							$(element).closest(".k-slider").parent().prepend(label, divContainer.firstChild);
							$(element).closest(".k-slider").parent()[0].style.cssText += "display: inline-flex; flex-direction: row;";
							label.style.cssText += "margin-right: 5px";

							window.setTimeout(() => (element as HTMLElement).style.cssText += "width: Calc(100% - " + ($(label).width() + 6) + "px)");
						}
						break;
				}
				//#endregion

				$(element).closest(".k-slider").parent().attr("id", element.id + "Parent");
				$(element).closest(".k-slider").parent().addClass("controlParent");
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).parentElement!.parentElement!.style.cssText += options.css;
			//#endregion

			//#region Color
			$(element).parent().find(".k-slider-selection").css("background-color", options.color);
			$(element).parent().find(".k-draghandle").css("background-color", options.color);
			//#endregion

			//#region Enabled
			(element as HTMLInputElement).disabled = !options.enabled
			//#endregion
		}

		clear()
		{
			let options = this.getOptions();
			this.value(options.min!);
		}

		getOptions()
		{
			return (this.options as SliderOptions);
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().prependTo(element);
		}
		//#endregion
	}

	Slider.fn = Slider.prototype;
	Slider.fn.options = $.extend(true, {}, kendo.ui.Slider.fn.options);
	Slider.fn.options.name = "Slider";
	kendo.ui.plugin(Slider);
}

interface JQuery
{
	kendoSlider(options?: KendoWidgets.SliderOptions): JQuery;
}